// import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default class {

  constructor ($el) {
    this.$el = $el
    this.isOpen = false
  }

  init () {
    $('#btnOpenForm,#btnfootcount,#btnfootcount1').on('click', function (event) {
      event.preventDefault();
      $('.form-popup-bg').addClass('is-visible');
    });

    $('.form-popup-bg').on('click', function (event) {
      if ($(event.target).is('.form-popup-bg') || $(event.target).is('#btnCloseForm')) {
        event.preventDefault();
        $(this).removeClass('is-visible');
      }
    });
    
    $('body').on('click', '.js-mini-cart', (e) => {
      e.preventDefault()
      this.open()
    })
    // this.$el.on('click', '.js-close-cart', () => {
    //   this.close()
    // })
    $('body').on('click', '.js-close-cart', () => {
      this.close()
    })
  }

  open () {
    this.$el.addClass('is-open')
    $('.layout').addClass('is-open')
    this.buildOverlay()
    // $('body').addClass('overflow-hidden')
    // There seem to be issue with lazy loaded image aren't triggered properly
    // this is a temporary work around until there is a permanent way to do it
    if (window._lazy) {
      window._lazy.update()
    }

    // this.$overlay.addClass('is-open')
    this.isOpen = true
  }

  close () {
    this.$el.removeClass('is-open')
    $('.layout').removeClass('is-open')
    // $('body').removeClass('overflow-hidden')
    this.closeOverlay()
    // this.$overlay.removeClass('is-open')
    this.isOpen = false
  }

  buildOverlay () {
    this.$overlay = $('<div class="fixed inset-0 z-popup-overlay opacity-75 bg-white"></div>')
    this.$overlay.appendTo('body')
    // disableBodyScroll(this.$el[0])
    this.$overlay.on('click', () => {
      this.close()
    })
  }

  closeOverlay () {
    if (!this.$overlay) {
      return
    }
    this.$overlay.off('click')
    this.$overlay.remove()
    // enableBodyScroll(this.$el[0])
    this.$overlay = null
  }

}



// WEBPACK FOOTER //
// ./scripts/components/mini-cart.js